import type { DotLottie, DotLottieReactProps } from '@lottiefiles/dotlottie-react';
import dynamic from 'next/dynamic';
import { forwardRef, useState } from 'react';
import type { ComponentType } from 'react';

import styles from '../DotLottieReactLoader.module.scss';
import type { DotLottieReactLoaderProps } from '../types/DotLottieReactLoader.types';

const DotLottieReact = dynamic<DotLottieReactProps>(
  () =>
    /* webpackPrefetch: true */ import('@lottiefiles/dotlottie-react').then(
      (mod) => mod.DotLottieReact as unknown as ComponentType<DotLottieReactProps>,
    ),
  { ssr: false },
);

export const DotLottieReactLoader = forwardRef<HTMLDivElement, DotLottieReactLoaderProps>((props, ref) => {
  const { width, height, className, fallbackImage, onPlay: propOnPlay, ...rest } = props;

  const [isPlaying, setIsPlaying] = useState(false);

  const onPlay = () => {
    setIsPlaying(true);
    propOnPlay?.();
  };

  const dotLottieRefCallback = (dotlottie: DotLottie | null) => {
    dotlottie?.addEventListener('play', onPlay);
  };

  return (
    <div
      className={className}
      ref={ref}
    >
      <div
        className={styles.lottieContainer}
        style={{ width, height }}
      >
        {fallbackImage && !isPlaying && (
          <img
            src={fallbackImage as string}
            alt=""
            width={width}
            height={height}
          />
        )}
        <DotLottieReact
          className={styles.lottie}
          dotLottieRefCallback={dotLottieRefCallback}
          {...rest}
        />
      </div>
    </div>
  );
});
